<button
  data-testId="upload-initiated-button"
  *ngIf="canUploadMeasurement()"
  class="btn btn-sm btn-primary ms-2 me-2 mb-1"
  (click)="uploadInitiated()"
  [title]="'measurementsGridButtonTitleUploadMeasurement' | localize">
  <i class="fa fa-upload"></i>
</button>
